import { type Post, PostType } from '@prisma/client';
import { Link, useLoaderData } from 'react-router'
import WatchCTA from '#app/routes/resources+/watch-cta.tsx'
import { formatMonthAsText } from '#app/utils/date.ts';
import { getAllPosts } from '#app/utils/posts.server.ts';
import { type Route } from './+types/index.ts'

export const meta = ({ loaderData }: Route.MetaArgs) => {
	var title = `JaseOwns - ${loaderData?.totalCount} Videos`;
	var description = "My journey learning YouTube and all my video posts.";
	return [
		{ title: title },
	  	{ name: "description", content: description},
	  	{ name: "keywords", content: "youtube,videos,uo,ultima online,self taught,learning,jaseowns,jase,jason"},
		{ property: "og:image", content: "https://jaseowns.com/images/going-back-to-dev.png"},
		{ property: "og:image:alt", content: "Meme about being a developer"},
		{ property: "twitter:card", content: "summary"},
		{ property: "twitter:creator", content: "@jaseowns"},
		{ property: "twitter:site", content: "@jaseowns"},
		{ property: "og:title", content: title},
		{ property: "og:description", content: description},
	];
  };


  export async function loader({ request }: Route.LoaderArgs) {

	const posts = await getAllPosts(PostType.VIDEO)

	const recentPosts = posts.filter(x => {
		var sixMonthsAgo = new Date();
		sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
		if (x.publishedAt.getFullYear() < sixMonthsAgo.getFullYear()) return false;
		return x.publishedAt.getTime() >= sixMonthsAgo.getTime()
	});
	const olderPosts = posts.filter(x => {
		var sixMonthsAgo = new Date();
		sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
		if (x.publishedAt.getFullYear() < sixMonthsAgo.getFullYear()) return true;
		return x.publishedAt.getTime() < sixMonthsAgo.getTime()
	});

	
	return {
			recentPosts,
			olderPosts,
			totalCount: posts.length,
		}
	
}

function displayListOfPosts(posts: Post[]) {
	var yearKey = "";
	var monthKey = "";

	return <div className="">{posts.map((x, index) => {
		var yearSplit = <></>
		var monthSplit = <></>
		var theDate = new Date(x.publishedAt);

		if (yearKey != theDate.getFullYear().toString()) {
			yearSplit = <div className="dark:bg-cyan-900 max-w-md bg-cyan-600 text-white p-6 text-3xl font-bold my-6">{theDate.getFullYear()}</div>
			yearKey = theDate.getFullYear().toString();
			monthKey ="";
			monthSplit = <></>;
		}

		if (monthKey != theDate.getMonth().toString()) {
			monthSplit = <div className="text-2xl font-bold my-3">{formatMonthAsText(theDate.getMonth()+1)}</div>
			monthKey = theDate.getMonth().toString();
		}

		var flipStyle = index % 2 ? "md:flex-row" : "md:flex-row-reverse";

		return <div className="px-4" key={x.id}>
			{yearSplit} {monthSplit} 
			<div className="flex flex-col md:flex-row">
				<Link className={`hover:bg-slate-500 p-6 text-center justify-center md:text-left underline text-2xl flex flex-col  md:text-3xl py-5 ${flipStyle}`} to={`/videos/${x.slug}`}>
					<img loading="lazy" className="mx-auto max-w-xs md:max-w-sm flex-col md:flex-row" src={`https://img.youtube.com/vi/${x.youtubeId}/0.jpg`} alt={`${x.title} thumbnail`} />
					<span className="my-6 md:my-auto mx-2 md:mx-8">{x.title}</span>
				</Link>
			</div>
		</div>
	})}
	</div>
}

export default function Index() {
	const data = useLoaderData<typeof loader>()

	// Convert string dates back to Date objects
	const convertPostDates = (post: any) => ({
		...post,
		publishedAt: new Date(post.publishedAt),
		lastUpdatedAt: new Date(post.lastUpdatedAt),
		createdAt: new Date(post.createdAt),
		updatedAt: new Date(post.updatedAt)
	});

	const recentPostsWithDates = data.recentPosts.map(convertPostDates);
	const olderPostsWithDates = data.olderPosts.map(convertPostDates);

	return (
		<main className="container mx-auto text-black dark:text-white">
			<h1 className="text-3xl px-10 mb-6 text-cyan-900 dark:text-cyan-200">Videos ({data.totalCount})</h1>
			<div className="px-10">
				<img src="/images/emotes/surprised_2048.png" alt="surprised emote" className='h-24 float-left m-8' />
				<div className="flex flex-col md:flex-row my-6">
					Welcome to my YouTube video hub! Looking for past live streams? Check out the <Link to="/livestreams" className="underline text-cyan-600 dark:text-cyan-400 mx-1">Livestreams</Link> page.
				</div>
			</div>
			<h1 className="text-3xl px-4 mt-8 m-2 mb-6 text-cyan-900 dark:text-cyan-200 clear-both">Recent Video Posts ({data.recentPosts.length})</h1>
				{displayListOfPosts(recentPostsWithDates)}
			<h1 className="text-3xl px-4 mt-12 m-2 mb-6 text-cyan-900 dark:text-cyan-200">Older Video Posts ({data.olderPosts.length})</h1>
				{displayListOfPosts(olderPostsWithDates)}
			<div className="flex flex-wrap justify-center gap-8 rounded-3xl py-4 mt-10">
				{WatchCTA()}
			</div>
		</main>
	)
}
